module.exports = __webpack_public_path__ + "img/description.d4ef8b53.png";